<template>
  <a-modal
    v-model="visible"
    :title="$t('mouse.firmwareUpdateTitle')"
    :width="600"
    :closable="true"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <div class="update-confirm-modal">
      <div class="modal-instruction">
        {{ $t("mouse.firmwareUpdateInstruction") }}
      </div>
      <div class="modal-requirement">
        {{ $t("mouse.firmwareUpdateRequirement") }}
      </div>

      <!-- 有线连接状态 -->
      <div class="connection-item" :class="{ connected: isWiredConnected }">
        <div class="connection-icon wired" :class="{ connected: isWiredConnected }">
          <img v-if="isWiredConnected" src="@/assets/images/icon_dongle_active.svg" alt="Dongle" />
          <img v-else src="@/assets/images/icon_dongle.svg" alt="Dongle" />
        </div>
        <div class="connection-info">
          <div class="connection-status" :class="{ connected: isWiredConnected }">
            {{ isWiredConnected ? $t("mouse.wiredConnection") : $t("mouse.mouseUSB") }}
          </div>
          <!-- <div class="connection-version" v-if="mouseVersion && isWiredConnected">
            {{ $t("mouse.currentVersion") }}{{ mouseVersion }}
            <span v-if="mouseifNew" class="version-arrow">→</span>
            <span v-if="mouseifNew" class="new-version">{{ $t("mouse.newVersion") }}</span>
          </div> -->
        </div>
      </div>

      <!-- Dongle 连接状态 -->
      <div class="connection-item" :class="{ connected: isDongleConnected }">
        <div class="connection-icon dongle" :class="{ connected: isDongleConnected }">
          <img
            class="img-icon"
            src="@/assets/images/icon_mouse_dongle.svg"
            alt="Dongle"
            :class="{ connected: isDongleConnected }"
          />
        </div>
        <div class="connection-info">
          <div class="connection-status" :class="{ connected: isDongleConnected }">
            {{ isDongleConnected ? $t("mouse.dongleConnection") : $t("mouse.dongleUSB") }}
          </div>
          <!-- <div class="connection-version" v-if="dongleVersion && isDongleConnected">
            {{ $t("mouse.currentVersion") }}{{ dongleVersion }}
            <span v-if="dongleifNew" class="version-arrow">→</span>
            <span v-if="dongleifNew" class="new-version">{{ $t("mouse.newVersion") }}</span>
          </div> -->
        </div>
      </div>
    </div>

    <template slot="footer">
      <a-button @click="handleCancel">{{ $t("cancel") }}</a-button>
      <a-button type="primary" @click="handleConfirm" :disabled="!canUpdate">
        {{ $t("loader.update") }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "FirmwareUpdateModal",
  props: {
    // 控制弹窗显示
    value: {
      type: Boolean,
      default: false,
    },
    // 有线连接状态
    isWiredConnected: {
      type: Boolean,
      default: false,
    },
    // Dongle 连接状态
    isDongleConnected: {
      type: Boolean,
      default: false,
    },
    // 鼠标版本信息
    mouseVersion: {
      type: String,
      default: "",
    },
    // 鼠标是否有新版本
    mouseifNew: {
      type: Boolean,
      default: false,
    },
    // Dongle 版本信息
    dongleVersion: {
      type: String,
      default: "",
    },
    // Dongle 是否有新版本
    dongleifNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // 是否可以更新（两个设备都连接）
    canUpdate() {
      return this.isWiredConnected && this.isDongleConnected;
    },
  },
  methods: {
    // 确认更新
    handleConfirm() {
      if (this.canUpdate) {
        this.$emit("confirm");
      }
    },
    // 取消更新
    handleCancel() {
      this.$emit("cancel");
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.update-confirm-modal {
  padding: 10px 5px;

  .modal-instruction {
    font-size: 22px;
    color: #ffffff;
    margin-bottom: 16px;
    text-align: center;
    font-weight: 500;
    line-height: 1.5;
  }

  .modal-requirement {
    font-size: 18px;
    color: #888888;
    margin-bottom: 35px;
    text-align: center;
    line-height: 1.6;
  }

  .connection-item {
    display: flex;
    align-items: center;
    padding: 28px 24px;
    margin-bottom: 18px;
    border-radius: 20px;
    border: none;
    position: relative;
    overflow: hidden;
    
    // 使用更平滑的缓动函数和更长的过渡时间
    transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1),
                box-shadow 0.5s ease-out,
                border 0.4s ease;

    // 未连接状态 - 凹陷效果
    background: linear-gradient(145deg, #1a1a1a, #151515) !important;
    box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.5),
      inset -4px -4px 10px rgba(255, 255, 255, 0.02) !important;

    &:last-child {
      margin-bottom: 0;
    }

    // 连接状态 - 扁平化效果
    &.connected {
      background: linear-gradient(145deg, #1f1f1f, #1a1a1a) !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05) !important;
      transform: translateY(-1px);
      border: 1px solid #8730f8;
    }

    .connection-icon {
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-right: 24px;
      flex-shrink: 0;
      position: relative;
      
      // 更平滑的过渡效果
      transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1),
                  box-shadow 0.5s ease-out,
                  background 0.5s ease;

      // 未连接状态 - 凹陷效果
      background: linear-gradient(145deg, #141414, #101010) !important;
      border: none !important;
      box-shadow: inset 3px 3px 8px rgba(0, 0, 0, 0.6),
        inset -3px -3px 8px rgba(255, 255, 255, 0.02) !important;

      // 连接状态 - 毛玻璃效果
      &.connected {
        background: rgba(255, 255, 255, 0.02) !important;
        backdrop-filter: blur(10px) !important;
        -webkit-backdrop-filter: blur(10px) !important;
        border: none !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.08),
          inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;
        transform: scale(1.05);
      }

      // Dongle 图标样式 - 精确颜色控制
      .img-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        // 只过渡透明度和变换，不过渡 filter（避免中间色）
        transition: opacity 0.4s ease,
                    transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);

        // 未连接：灰色 #9f9f9f
        filter: brightness(0) saturate(100%) invert(64%) sepia(0%) saturate(0%) hue-rotate(0deg)
          brightness(98%) contrast(88%);
        opacity: 0.6;
        transform: scale(1);

        &.connected {
          // 已连接：紫色 #8028f5 + 发光效果
          filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(4500%)
            hue-rotate(260deg) brightness(100%) contrast(101%)
            drop-shadow(0 0 10px rgba(128, 40, 245, 0.8));
          opacity: 1;
          transform: scale(1.05);
        }
      }

      // SVG 图标样式
      img:not(.img-icon) {
        width: 45px;
        height: 45px;
        object-fit: contain;
        transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
      }
    }

    .connection-info {
      flex: 1;

      .connection-status {
        font-size: 19px;
        font-weight: 600;
        color: #666666;
        margin-bottom: 10px;
        // 添加文字过渡动画
        transition: color 0.5s ease,
                    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

        &.connected {
          color: #8028f5; // 紫色主题
          transform: translateX(2px);
        }
      }

      .connection-version {
        font-size: 15px;
        color: #999999;
        line-height: 1.6;
        transition: color 0.5s ease,
                    opacity 0.4s ease;

        .version-arrow {
          margin: 0 10px;
          color: #999999;
          font-weight: bold;
          font-size: 17px;
          display: inline-block;
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .new-version {
          font-weight: 600;
          transition: color 0.5s ease;
        }
      }
    }
  }
}
</style>

<style lang="scss">
// 固件升级确认弹窗的全局样式
// 使用紫色主题色 #8028f5
.ant-modal-wrap {
  .ant-modal {
    // Modal 标题栏样式 - 纯黑色背景，无边框
    .ant-modal-header {
      background-color: #202020 !important;
      border-bottom: none !important;
      padding: 24px 30px 20px !important;
      border-radius: 20px 20px 0 0 !important;

      .ant-modal-title {
        color: #ffffff !important;
        font-size: 22px !important;
        font-weight: 600 !important;
      }
    }

    // Modal 内容区域样式 - 紫色边框
    .ant-modal-content {
      background-color: #202020 !important;
      border: 0 !important;
      border-radius: 20px !important;
      box-shadow: none !important;
    }

    .ant-modal-body {
      background-color: #202020 !important;
      padding: 30px 30px 35px !important;
    }

    // Modal 底部按钮区域样式
    .ant-modal-footer {
      background-color: #202020 !important;
      padding: 20px 30px 28px !important;
      border-radius: 0 0 20px 20px !important;
      border-top: 0;

      .ant-btn {
        height: 50px !important;
        font-size: 20px !important;
        border-radius: 10px !important; // 与外面按钮一致的圆角
        min-width: 130px !important;
        font-weight: 500 !important;
        transition: all 0.3s ease !important;

        // 取消按钮 - 透明背景带边框
        &:not(.ant-btn-primary) {
          background-color: transparent !important;
          border: 1.5px solid rgba(255, 255, 255, 0.2) !important;
          color: #ffffff !important;

          &:hover {
            border-color: rgba(255, 255, 255, 0.35) !important;
          }
        }

        // 升级按钮 - 渐变背景（与外面按钮一致）
        &.ant-btn-primary {
          @include linear-button;
          height: 50px !important;
          border-radius: 10px !important; // 与外面按钮一致的圆角
          min-width: 130px !important;
          font-weight: 500 !important;
          transition: all 0.3s ease !important;
          border: none;
          margin-left: 20px;
          &:hover:not(:disabled) {
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }
    }

    // 关闭按钮样式 - 调大并与标题对齐
    .ant-modal-close {
      color: #ffffff !important;
      top: 0 !important;
      right: 24px !important;
      width: 40px !important;
      height: 40px !important;
      line-height: 40px !important;

      .ant-modal-close-x {
        width: 60px !important;
        height: 60px !important;
        line-height: 60px !important;
        font-size: 24px !important;
      }

      &:hover {
        color: #8028f5 !important;
      }
    }
  }
}
</style>
